/* istanbul ignore file -- api */
import { useServiceUrls } from '@ori/configuration-manager';
import { useGraphqlQuery } from '@ori/fetching';
import { useHeaders } from '@ori/presentation-http';
import { useMemo } from 'react';
import { getProductShades } from '../queries-net';
import { mapProductShadesQuery } from '../utils/mapProductShadesQuery';
export const useGetProductShades = ({
  productCode,
  enabled = true
}) => {
  const {
    graphQlNetUrl
  } = useServiceUrls(['graphQlNet']);
  const {
    headers,
    loading: loadingHeaders
  } = useHeaders();
  const {
    data,
    isValidating,
    error
  } = useGraphqlQuery({
    query: getProductShades,
    url: graphQlNetUrl,
    headers,
    variables: {
      productCode
    },
    skip: loadingHeaders || !enabled,
    swrConfig: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  const loading = useMemo(() => isValidating || !data && !error, [data, error, isValidating]);
  const result = useMemo(() => ({
    data: data ? mapProductShadesQuery(data) : undefined,
    loading,
    error
  }), [data, error, loading]);
  return result;
};
//# sourceMappingURL=useGetProductShades.js.map